export default function Contact() {
  return (
    <section className="bg-gray-100 text-gray-800 py-12 px-4" id="contact">
      <h2 className="text-3xl font-bold text-center mb-6">Contact Me</h2>
      <div className="max-w-md mx-auto">
        <p className="text-center mb-4">Have a project in mind or just want to say hi?</p>
        <a
          href="mailto:khanfatimamohamed@gmail.com"
          className="block w-full text-center bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded"
        >
          Send Email
        </a>
      </div>
    </section>
  );
}
